import FilterZipcodeDrawerDialog from '../filter-zipcode-drawer-dialog';
import { useFilterZipcodeDrawerDialog } from '@/common/hooks/use-filter-zipcode-drawer-dialog';
import { Session } from '@/common/types';
import { useActionData } from 'react-router';
import { CatalogAction } from '@/catalog/types/catalog-action';
import PlanAgeCreditPills, {
  PlanAgeCreditPillsProps,
} from '../filters/plan-age-credit-pills';
import { cn } from '@/shadcn-ui/utils';

interface HeaderContainerProps {
  session?: Session;
  dark?: boolean;
  planAgeCreditConfig?: PlanAgeCreditPillsProps;
  pillClassName?: string;
}

export default function HeaderContainer({
  session,
  dark,
  planAgeCreditConfig,
  pillClassName,
}: HeaderContainerProps) {
  const actionData = useActionData<CatalogAction>();

  const {
    selectedZipcode,
    zipcodeModalOpen,
    submitZipcode,
    handleZipcodeModalOpen,
    handleZipcodeModalClose,
  } = useFilterZipcodeDrawerDialog({ actionData, session });

  if (planAgeCreditConfig) {
    return (
      <>
        <FilterZipcodeDrawerDialog
          dark={false}
          selectedZipcode={selectedZipcode}
          open={zipcodeModalOpen}
          submitZipcode={submitZipcode}
          handleOpen={handleZipcodeModalOpen}
          handleClose={handleZipcodeModalClose}
          pillClassName={cn(
            'bg-transparent md:bg-flexcar-neutral90 rounded-[8px] text-flexcar-neutral1',
            pillClassName
          )}
        />

        <PlanAgeCreditPills
          planHandleClose={planAgeCreditConfig.planHandleClose}
          planOpen={planAgeCreditConfig.planOpen}
          planHandleOpen={planAgeCreditConfig.planHandleOpen}
          planError={planAgeCreditConfig.planError}
          creditHandleClose={planAgeCreditConfig.creditHandleClose}
          creditOpen={planAgeCreditConfig.creditOpen}
          creditHandleOpen={planAgeCreditConfig.creditHandleOpen}
          creditError={planAgeCreditConfig.creditError}
          creditScores={planAgeCreditConfig.creditScores}
          ageRanges={planAgeCreditConfig.ageRanges}
          selectedPlanMileage={planAgeCreditConfig.selectedPlanMileage}
          selectedCreditScoreId={planAgeCreditConfig.selectedCreditScoreId}
          selectedAgeRangeId={planAgeCreditConfig.selectedAgeRangeId}
          selectedAge={planAgeCreditConfig.selectedAge}
          canViewSwap={planAgeCreditConfig.canViewSwap ?? false}
          canLegacySwap={planAgeCreditConfig.canLegacySwap ?? false}
          mileagePlans={planAgeCreditConfig.mileagePlans}
          hideCreditModal={planAgeCreditConfig.hideCreditModal}
          fullstoryEventDelegate={planAgeCreditConfig.fullstoryEventDelegate}
          pillClassName={cn(
            'bg-transparent lg:bg-flexcar-neutral90 rounded-[8px] text-flexcar-neutral1 hidden lg:inline-flex',
            pillClassName
          )}
        />
      </>
    );
  }

  return (
    <FilterZipcodeDrawerDialog
      dark={dark ?? true}
      selectedZipcode={selectedZipcode}
      open={zipcodeModalOpen}
      submitZipcode={submitZipcode}
      handleOpen={handleZipcodeModalOpen}
      handleClose={handleZipcodeModalClose}
      pillClassName={pillClassName}
    />
  );
}
